import { DocumentIdentifier } from "./DocumentIdentifier";
import { IDocumentReferable } from "./IDocumentReferable";
import { IDocumentSource } from "./IDocumentSource";

export class DocumentReference extends DocumentIdentifier implements IDocumentReferable {
  constructor(
    id: number,
    patientNo: string,
    public readonly edition: number,
    public readonly previewSource: IDocumentSource,
    public readonly printSource: IDocumentSource,
    public readonly isPrintable: boolean,
    public readonly defaultCopies: number,
    public readonly isUnmanaged: boolean,
  ) {
    super(id, patientNo);
  }
}
